<div class="delete-citations-dialog">
  <span class="close-btn-container">
    <button class="mat-icon-button close-icon" (click)="cancel()">
      <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color"
        >close</mat-icon
      >
    </button>
  </span>
  <ng-container *ngIf="isNumberedRef; else unnumberedRefDesc">
    <div class="delete-references-dialog-content">
      <h1 class="heading delete-references-heading">
        {{ 'APP.CITATIONS.DELETE_REFERENCE_DIALOG_TITLE' | translate }}
      </h1>
      <div class="delete-references-title">
        <ng-container
          *ngIf="
            data.multipleRef && data.multipleRef.length > 1;
            else singleOrFromRHP
          "
        >
          <p>
            {{
              'APP.CITATIONS.DELETE_MULTIPLE_REFERENCES_DIALOG_DESC'
                | translate
                  : { multipleRefsToDeletePlaceholder: citationStrings }
            }}
          </p>
          <p *ngFor="let reference of data.multipleRef">
            {{
              'APP.CITATIONS.DELETE_REFERENCE_DIALOG_MULTIPLE_CITED_CITATIONS'
                | translate
                  : {
                      dataCitationCount: reference.citationName,
                      totalCitationRefCountPlaceholder:
                        reference.citationTotalCount
                    }
            }}
          </p>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-template #singleOrFromRHP>
    <ng-container *ngIf="!data.multipleRef; else singleFromDoc">
      <p>{{ 'APP.CITATIONS.DELETE_REFERENCE_DIALOG_DESC' | translate }}</p>
      <p>
        {{
          'APP.CITATIONS.DELETE_REFERENCE_DIALOG_TOTAL_CITED_CITATIONS'
            | translate
              : { totalCitationRefCountPlaceholder: data.totalCitedCount }
        }}
      </p>
    </ng-container>
    <ng-template #singleFromDoc>
      <p>
        {{
          'APP.CITATIONS.DELETE_REFERENCE_FROM_DOC_DIALOG_DESC'
            | translate
              : { citationCount: '[' + data.multipleRef[0].citationName + ']' }
        }}
      </p>
      <p>
        {{
          'APP.CITATIONS.DELETE_REFERENCE_FROM_DOC_DIALOG_TOTAL_CITED_CITATIONS'
            | translate
              : {
                  totalCitationRefCountPlaceholder:
                    data.multipleRef[0].citationTotalCount,
                  citationCount: data.multipleRef[0].citationName
                }
        }}
      </p>
    </ng-template>
  </ng-template>
  <ng-template #unnumberedRefDesc>
    <div class="delete-unnumbered_references-dialog-content">
      <h1 class="heading">
        {{
          'APP.CITATIONS.DELETE_UNNUMBERED_REFERENCE_DIALOG_TITLE' | translate
        }}
      </h1>
      <p class="delete-citations-title">
        {{
          'APP.CITATIONS.DELETE_UNNUMBERED_REFERENCE_DIALOG_DESC' | translate
        }}
      </p>
    </div>
  </ng-template>
  <div class="delete-dialog-actions">
    <button type="button" class="wk-button wk-button-text" (click)="cancel()">
      {{ 'APP.CITATIONS.CANCEL' | translate }}
    </button>
    <button
      type="button"
      class="wk-button wk-button-danger"
      (click)="confirm()"
    >
      {{ 'APP.CITATIONS.DELETE' | translate }}
    </button>
  </div>
</div>
